import React, { useReducer, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import {
  combineReducers,
  globalDispatchContext,
  globalStateContext,
  initalState,
} from 'store';
import { CONST } from 'reducers';

import { Home } from './features/Home';
import { Company } from './features/Company';
import { Message } from './features/Common';
import { AuthGuard } from './features/Auth';

function App(): React.ReactElement {
  const [state, dispatchToGlobal] = useReducer(combineReducers, initalState);
  console.log('@@state', state);
  useEffect(() => {
    dispatchToGlobal({ type: CONST.APP_INIT });
  }, []);
  return (
    <div className="App">
      <globalDispatchContext.Provider value={{ dispatch: dispatchToGlobal }}>
        <globalStateContext.Provider value={{ ...state }}>
          <Router>
            <Switch>
              <Route path="/" exact>
                <Home />
              </Route>
              <AuthGuard path="/company/:sig">
                <Company />
              </AuthGuard>
              <AuthGuard path="/agency/:sig">
                <Company />
              </AuthGuard>
              <AuthGuard path="/agent/:sig">
                <Company />
              </AuthGuard>
              <Route path="*">
                <div>NO PAGE FOUND</div>
              </Route>
            </Switch>
          </Router>
          <Message />
        </globalStateContext.Provider>
      </globalDispatchContext.Provider>
    </div>
  );
}

export default App;
